import { render } from "./MainComponent.vue?vue&type=template&id=a707381c&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=a707381c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a707381c"]])

export default __exports__